import { Switch, Route } from 'react-router-dom';
import JobContainer from './JobContainer';

const JobRoutes = () => {
  return (
    <Switch>
      <Route path="/jobs" exact component={JobContainer} />
    </Switch>
  );
};

export default JobRoutes;
